<template>
  <div class="">
    <!-- <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="68px"
    >
      <el-form-item label="配饰名称" prop="name">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入配饰名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input
          v-model="queryParams.remarks"
          placeholder="请输入备注"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form> -->

    <el-row :gutter="10" class="mb8 mt10">
      <right-toolbar
        :showSearch.sync="showSearch"
        @queryTable="getList"
      ></right-toolbar>
    </el-row>

    <el-table
      v-loading="loading"
      :data="accessoryList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        label="抢单人"
        align="center"
        prop="nickName"
        show-overflow-tooltip
      />
      <el-table-column
        label="手机号"
        align="center"
        prop="phone"
        show-overflow-tooltip
      />

      <el-table-column
        label="状态"
        align="center"
        prop="status"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.status == 1" type="warning">待确认</el-tag>
          <el-tag v-if="row.status == 2">已确认</el-tag>
          <el-tag v-if="row.status == 3" type="success">已完成</el-tag>
          <el-tag v-if="row.status == 4" type="info">已取消</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="抢单时间"
        align="center"
        prop="createTime"
        show-overflow-tooltip
      />
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-collection"
            v-if="storeId == parentUserId"
            @click="handleComment(scope.row)"
            >抢单人历史评价</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-check"
            v-if="scope.row.status == 1 && storeId == parentUserId"
            @click="handleConfirm(scope.row)"
            >确认</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-close"
            v-if="scope.row.status == 1 && storeId == parentUserId"
            @click="handleDelete(scope.row)"
            >取消</el-button
          >

          <el-button
            size="mini"
            type="text"
            v-if="
              scope.row.status == 3 &&
              storeId == parentUserId &&
              scope.row.isComment == 0
            "
            icon="el-icon-thumb"
            @click="handlePingJia(scope.row)"
            >评价</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 历史评价 列表 -->
    <el-drawer :title="title" :visible.sync="open" size="40%" append-to-body>
      <el-table v-loading="loading" :data="commentList">
        <el-table-column
          label="评价人"
          align="center"
          prop="commentNickName"
          show-overflow-tooltip
        />
        <el-table-column
          label="评价人用户类型"
          align="center"
          prop="commentUserType"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span v-if="row.commentUserType == 1">用户</span>
            <span v-if="row.commentUserType == 2">店铺</span>
          </template>
        </el-table-column>
        <el-table-column
          label="内容"
          align="center"
          prop="content"
          show-overflow-tooltip
        />

        <!-- <el-table-column
          label="状态"
          align="center"
          prop="status"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <el-tag v-if="row.status == 1" type="warning">待确认</el-tag>
            <el-tag v-if="row.status == 2" type="success">已确认</el-tag>
            <el-tag v-if="row.status == 3" type="info">已取消</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column
          label="评价时间"
          align="center"
          prop="createTime"
          show-overflow-tooltip
        />
      </el-table>

      <pagination
        v-show="total1 > 0"
        :total="total1"
        :page.sync="queryParams1.pageNum"
        :limit.sync="queryParams1.pageSize"
        @pagination="getCommentList"
      />
    </el-drawer>

    <!-- 评价 -->
    <el-dialog title="评价" :visible.sync="open1" append-to-body>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="评价内容" prop="content">
          <el-input v-model="form.content" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import {
  listAccessory,
  getAccessory,
  commentGrabbing,
  cancelGrabbing,
  confirmGrabbing,
  updateAccessory,
  insertComment,
} from "@/api/accessory";

export default {
  name: "Accessory",
  props: ["setId", "parentUserId"],
  data() {
    return {
      id: "请输入内容",
      val: "",
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      total1: 0,
      // 商品配饰表格数据
      accessoryList: [],
      // 弹出层标题
      title: "",
      commentList: [], // 历史评价 列表
      // 是否显示弹出层
      open: false,
      open1: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        goodsId: null,
        name: null,
        content: null,
        remarks: null,
        id: null,
        url: this.$route.query.url,
      },
      queryParams1: {
        pageNum: 1,
        pageSize: 10,
        commentUserId: "",
        url: this.$route.query.url,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        content: [
          { required: true, message: "评价内容不能为空", trigger: "blur" },
        ],
      },
      storeId: "",
    };
  },
  created() {
    this.getList();
    this.storeId = this.$route.query.storeId;
    console.log(this.parentUserId, "parentUserId");
  },
  methods: {
    /** 查询商品配饰列表 */
    getList() {
      this.loading = true;
      this.queryParams.demandId = this.setId;
      listAccessory(this.queryParams).then((response) => {
        this.accessoryList = response.data.list;
        this.total = response.data.total;
        this.loading = false;
        // console.log(" this.queryParams.goodsId", this.queryParams.goodsId);
      });
    },
    // 取消按钮
    cancel() {
      this.open1 = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        content: null,
        id: null,
        demandId: null,
        userId: null,
        userType: null,
        commentUserId: null,
        commentUserType: null,
        createTime: null,
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 评价按钮操作 */
    handlePingJia(row) {
      console.log(row);
      this.reset();
      this.form.id = row.id;
      this.form.demandId = row.demandId;
      this.form.userId = row.userId;
      this.form.userType = row.userType;
      this.form.commentUserId = this.storeId;
      this.form.commentUserType = 2;
      this.open1 = true;
    },
    /** 历史评价 按钮操作 */
    handleComment(row) {
      this.open = true;
      this.title = row.nickName + " - 历史评价";
      this.queryParams1.commentUserId = row.userId;
      this.getCommentList();
    },
    // 获取历史评价
    getCommentList() {
      commentGrabbing(this.queryParams1).then((response) => {
        this.commentList = response.data.list;
        this.total1 = response.data.total;
      });
    },
    /** 详情按钮操作 */
    handlesee(row) {
      this.reset();
      const id = row.id || this.ids;
      getAccessory(id).then((response) => {
        this.form = response.data;
        this.open = true;
        this.title = "详情";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          insertComment(this.form).then((response) => {
            this.$message({
              message: "评价成功",
              type: "success",
            });
            this.open1 = false;
            this.getList();
          });
        }
      });
    },
    /** 确认按钮操作 */
    handleConfirm(row) {
      this.$confirm("是否确认?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return confirmGrabbing({
            id: row.id,
            demandId: row.demandId,
          });
        })
        .then(() => {
          this.$message({
            message: "确认成功",
            type: "success",
          });
          this.getList();
        })
        .catch(() => {});
    },
    /** 取消按钮操作 */
    handleDelete(row) {
      this.$confirm("是否确认取消?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return cancelGrabbing({
            id: row.id,
            demandId: row.demandId,
          });
        })
        .then(() => {
          this.$message({
            message: "取消成功",
            type: "success",
          });
          this.getList();
        })
        .catch(() => {});
    },
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download(
        "system/accessory/export",
        {
          ...this.queryParams,
        },
        `accessory_${new Date().getTime()}.xlsx`
      );
    },
  },
};
</script>
  